import React from 'react';

import { PageIcon, SelectedPageIcon } from './Icon';

interface Props
{
  currentPage: number,
  totalPages: number,
  onPage: (page: number) => void,
}
const Pagination: React.FC<Props> = ({currentPage, totalPages, onPage}) =>
{
  const pages = [];
  for (let i = 0; i < totalPages; i++)
  {
    pages.push(i);
  }
  return (
    <>
      {
        pages.map(i => i === currentPage ? <SelectedPageIcon key={i} number={i}/> : <PageIcon key={i} number={i} action={onPage} />)
      }
    </>
  );
};

export default Pagination;